/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';

import { getDisplayObject, setActiveTab, resetState } from 'actions/objectActions';

import FieldDisplay from 'field/display/FieldDisplay';
import Loading from 'components/common/Loading';
import ArchivedObjectAccordions from 'components/archived-object/ArchivedObjectAccordions';

const DisplayView = ({ uri, parentUri, mode, 
  getDisplayObject, setActiveTab, resetState, defaultImage }) => {
  const loading = useSelector(state => state.object.loading);
  const active = useSelector(state => state.object.activeTab);
  const tabs = useSelector(state => state.object.tabs);

  useEffect(() => {
    getDisplayObject(uri, mode)
      .then(() => window.parent?.reloadTree(parentUri));
    return () => resetState();
  }, []);

  if (loading) {
    return <Loading />;
  }
  
  return <ArchivedObjectAccordions 
    tabs={tabs}
    Field={FieldDisplay}
    mode={mode}
    defaultImage={defaultImage}
  />;
};


export default connect(null, { getDisplayObject, setActiveTab, resetState })(DisplayView);